import { SearchSort } from '@aipb/gulliver/castor/model';
import { SearchRepository } from '@aipb/gulliver/catalog/data-access';
import { InsideLoadingComponent } from '@aipb/shared/ui/loading';
import { ViewportRuler } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NgxMasonryComponent, NgxMasonryModule } from 'ngx-masonry';
import { NgxMasonryOptions } from 'ngx-masonry/lib/ngx-masonry-options';
import { delay } from 'rxjs/operators';
import { ResultListMasonryItemComponent } from '../result-list-masonry-item/result-list-masonry-item.component';
import { ResultListBase } from '../result-list.base';

@UntilDestroy()
@Component({
  selector: 'cat-result-list-masonry',
  templateUrl: './result-list-masonry.component.html',
  styleUrls: ['./result-list-masonry.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, NgxMasonryModule, InsideLoadingComponent, ResultListMasonryItemComponent]
})
export class ResultListMasonryComponent extends ResultListBase implements OnInit, OnChanges {
  @Input() sort: SearchSort[] = [];

  @ViewChild(NgxMasonryComponent) masonry: NgxMasonryComponent;

  masonryOptions: NgxMasonryOptions = {
    itemSelector: '.masonry-item',
    columnWidth: '.grid-sizer',
    horizontalOrder: true,
    percentPosition: true
  };

  private searchRepository = inject(SearchRepository);
  private viewportRuler = inject(ViewportRuler);

  ngOnInit(): void {
    this.searchRepository.showFilters$.pipe(delay(500), untilDestroyed(this)).subscribe(() => {
      this.updateMasonry();
    });

    this.viewportRuler.change(500).subscribe(() => {
      this.updateMasonry();
    });
  }

  ngOnChanges(): void {
    this.updateMasonry();
    this.initDropboxImages(() => this.updateMasonry());
  }

  private updateMasonry(): void {
    if (!this.masonry) return;

    this.masonry.reloadItems();
    this.masonry.layout();
    window.dispatchEvent(new Event('resize'));
  }
}
